<template>
  <div style="padding-left: 1.75rem">
    <div class="col2_head">
      <router-link :to="'/'" class="breadcrumb_home">Acasă /</router-link>
      {{ $route.name }}
      <div class="subHeadTitle">{{ $route.name }} - {{ provider?.name }}</div>
      <div
        class="col2_subHead"
        style="margin-top: 1.2rem; display: flex; justify-content: flex-end"
      >
        <div
          class="Button1 Btn_center"
          :class="{ Btn_disabled: !totalRecords }"
          @click="generateExcel"
        >
          <div class="icon">
            <i class="fas fa-download"></i>
          </div>
          <span class="Btn_content"> Descarcă </span>
        </div>
      </div>
    </div>
    <template>
      <template v-if="PERMISIONS.list">
        <table-parent
          apiModuleName="ASSIGNMENT_PRODUCTS"
          :reloadCount="reloadTable"
          :tableHead="tableHead"
          :prepareFn="prepareData"
          :apiModule="tableModule"
          :searchModule="searchModule"
          :tableMinimizeHead="true"
          :tableSpread="true"
          @totalRecords="(x) => (totalRecords = x)"
          @filterQuery="(x) => (filterQuery = x)"
        />
      </template>
      <template v-else>
        <h3 style="display: flex; flex-direction: column; align-items: center">
          <span style="font-size: 4rem">
            <i class="fas fa-exclamation-triangle"></i>
          </span>
          Acces interzis
        </h3>
      </template>
    </template>
  </div>
</template>

<script>
import { saveAs } from "file-saver";
import PermisionsMixin from "@/mixins/institutionProviderPermMixin.js";
import updateRoleStatus from "../mixins/updateUserRoleStatus.js";
import { ASSIGNMENT_PRODUCTS, INSTITUTION_PROVIDERS } from "../api.js";
import TableParent from "@/components/TableParent";

export default {
  name: "InstitutionProviderProductsView",
  $Title() {
    return `ConectX - ${this.$route.name}`;
  },
  mixins: [PermisionsMixin, updateRoleStatus],
  components: {
    TableParent,
  },
  data() {
    return {
      tableHead: [
        {
          title: "Nume produs",
          queryKey: "product.name",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Descriere produs",
          queryKey: "description",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Cantitate",
          queryKey: "quantity",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Cotă TVA",
          queryKey: "tvaValue",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Valoare unitară",
          queryKey: "unitValue",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Valoare unitară, cu TVA",
          queryKey: "unitValueWithTva",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Valoarea totală",
          queryKey: "totalValueWithoutTva",
          bottomHead: {
            quikFiltre: true,
          },
        },

        {
          title: "Valoarea totală, cu TVA",
          queryKey: "totalValueWithTva",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Număr comandă",
          queryKey: "assignmentDocument.assignmentNumber",
          bottomHead: {
            quikFiltre: true,
          },
        },
      ],
      tableModule: (x, y, _, b) => {
        return ASSIGNMENT_PRODUCTS.getProductsForProvider(
          x,
          y,
          this.currentInstitutionProvider,
          b,
        );
      },
      totalRecords: 0,
      reloadTable: 0,
      filterQuery: "",
      provider: null,
    };
  },

  computed: {
    currentInstitutionProvider() {
      return this.$route.params.id;
    },
  },
  methods: {
    generateExcel() {
      this.setLoad(true);
      ASSIGNMENT_PRODUCTS.exportProductsForProvider(
        this.currentInstitutionProvider,
        this.filterQuery,
      ).then((res) => {
        var blob = new Blob([res], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, `raport-produse-furnizor-cui-${this.provider.cui}.xlsx`);
      });

      this.setLoad();
    },
    searchModule(x, y, _, b) {
      return ASSIGNMENT_PRODUCTS.getProductsForProvider(
        x,
        y,
        this.currentInstitutionProvider,
        b,
      );
    },
    reload() {
      this.reloadTable++;
    },

    prepareData(row) {
      const preparation = [];
      preparation.push(row.product.name);
      preparation.push(row.description);
      preparation.push(this.prepareLocaleNumber(row.quantity));
      preparation.push(this.prepareLocaleNumber(row.tvaValue));
      preparation.push(this.prepareLocaleNumber(row.unitValue));
      preparation.push(this.prepareLocaleNumber(row.unitValueWithTva));
      preparation.push(this.prepareLocaleNumber(row.totalValueWithoutTva));
      preparation.push(this.prepareLocaleNumber(row.totalValueWithTva));
      preparation.push(row.assignmentDocument.assignmentNumber);
      return preparation;
    },
  },
  created() {
    if (!this.PERMISIONS.list) {
      return;
    }

    this.updateRoleStatus();

    INSTITUTION_PROVIDERS.getOne(this.currentInstitutionProvider).then(
      (res) => {
        this.provider = res.data;
      },
    );
  },
};
</script>
